import React from 'react';

import { ImmutableEntity } from '@uncinc/react-drupal-core/types';
import ArticleTeaser from './Teaser';
import ArticlePage from './Page';
import { CustomNodeArticle } from '../custom';

type ArticleViewMode = 'teaser';

interface NodeArticleProps {
  entity: ImmutableEntity<CustomNodeArticle>;
  viewMode: ArticleViewMode;
  classes: string;
}

const NodeArticleWrapper: React.FC<NodeArticleProps> = ({ entity, viewMode, ...props }) => {
  switch (viewMode) {
    case 'teaser':
      return <ArticleTeaser entity={entity} {...props} />;
    default:
      return <ArticlePage entity={entity} {...props} />;
  }
};

export default NodeArticleWrapper;
